import React from 'react'
export default {
	id: 'empty',
	label: 'Empty',
	group: 'layout',
	Value: ({inEditor}) =>
		inEditor ? <>'This section intentionally left blank'</> : null,
}
